import React, {useEffect, useState} from "react";
import StringUtils from "src/utils/stringUtils";
import {Alert, Box, Button, FormField, Input, Modal, SpaceBetween} from "@amzn/awsui-components-react";

export default function CreateJEWorksheetTemplateModal(props: {visible: boolean,
    isCreating: boolean,
    createError: string,
    onClose: () => void,
    onSubmit: (t: string) => any }) {

    const { visible, isCreating, createError, onClose, onSubmit } = props;

    const [jeWorksheetTemplateName, setJEWorksheetTemplateName] = useState('');
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        if (visible) {
            setJEWorksheetTemplateName('');
            setShowError(false);
        }
    }, [visible])

    useEffect(() => {
        if (isCreating) {
            setShowError(true);
        }
    }, [isCreating])

    const disableCreate = () => {
        if (StringUtils.isNullOrEmpty(jeWorksheetTemplateName)) {
            return true;
        }
        return false;
    }

    return <Modal data-class="createJEWorksheetTemplateModal" visible={visible}
                  header="Create new JE Allocation worksheet template"
                  size="medium"
                  onDismiss={onClose}
                  footer={
                      <Box float="right">
                          <Button variant="link" className="cancelButton" disabled={isCreating} onClick={onClose}>Cancel</Button>
                          <Button variant="primary" className="createButton" disabled={isCreating || disableCreate()} onClick={() => onSubmit(jeWorksheetTemplateName)}>{isCreating ? 'Creating...' : 'Create JE worksheet template'}</Button>
                      </Box>
                  }>
        <SpaceBetween direction="vertical" size="m">
            <FormField  data-class="createModalField"
                        label="Enter JE worksheet template name*"
                        stretch={false}
            >
                <Input data-class="basicModalInput jeWorksheetNameFieldInput"
                       value={jeWorksheetTemplateName}
                       onChange={e => setJEWorksheetTemplateName(e.detail.value)}
                />
            </FormField>
            { showError && !StringUtils.isNullOrEmpty(createError) && <Alert type='error' dismissible={false}>{createError}</Alert> }
        </SpaceBetween>
    </Modal>
}
